import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTerceroForm } from '../Validations/ValidationsTercero';

export default function AddTerceroForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    tipoDocumento: 'NIF',
    documento: '',
    codigoPostal: '06000',
    provincia: '-',
    pais: '-',
    domicilio: '-',
    telefono: '900000000'
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [allTerceros, setAllTerceros] = useState([]);


/*
// Obtener el último DNI y asignar el siguiente
useEffect(() => {
  const fetchLastDni = async () => {
    try {
      const response = await axios.get('/terceros');
      const terceros = response.data || [];

      // Filtrar DNIs que siguen el formato "00000001*"
      const dniList = terceros
        .map(t => t.documento)
        .filter(dni => /^\d{8}\O$/.test(dni)) // Ahora busca 8 dígitos seguidos de "*"
        .map(dni => parseInt(dni.slice(0, 8), 10)); // Extrae solo los números

      // Obtener el último número y calcular el siguiente
      const lastNumber = dniList.length > 0 ? Math.max(...dniList) : 0;
      const nextDni = `${String(lastNumber + 1).padStart(8, '0')}O`; // 8 dígitos + "*"

      // Actualizar el estado con el nuevo DNI
      setFormData(prevData => ({
        ...prevData,
        documento: nextDni
      }));
    } catch (error) {
      console.error('Error obteniendo DNI:', error);
    }
  };

  fetchLastDni();
}, []);

*/

useEffect(() => {
  const fetchLastDniAndTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      const terceros = response.data || [];
      setAllTerceros(terceros); // Guardamos todos los terceros aquí

      const dniList = terceros
        .map(t => t.documento)
        .filter(dni => /^\d{8}O$/.test(dni))
        .map(dni => parseInt(dni.slice(0, 8), 10));

      const lastNumber = dniList.length > 0 ? Math.max(...dniList) : 0;
      const nextDni = `${String(lastNumber + 1).padStart(8, '0')}O`;

      setFormData(prevData => ({
        ...prevData,
        documento: nextDni
      }));
    } catch (error) {
      console.error('Error obteniendo DNI y terceros:', error);
    }
  };

  fetchLastDniAndTerceros();
}, []);


useEffect(() => {
  if (formData.nombre.length >= 3) {
    const filtered = allTerceros.filter(t =>
      t.nombre.toLowerCase().includes(formData.nombre.toLowerCase())
    );
    setSuggestions(filtered);
    setShowSuggestions(true);
  } else {
    setSuggestions([]);
    setShowSuggestions(false);
  }
}, [formData.nombre, allTerceros]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    const validationErrors = await validateTerceroForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/terceros', formData);
        navigate('/home/terceros');
      } catch (err) {
        console.error('Error saving tercero:', err);
        setServerError(err.response?.data?.message || 'Error al guardar el tercero. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Tercero</h2>
      {serverError && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">{serverError}</div>}
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
       
       
  <div className="mb-4 relative">
  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombre">
    Nombre
  </label>
  <input
    type="text"
    name="nombre"
    value={formData.nombre}
    onChange={handleChange}
    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.nombre ? 'border-red-500' : ''}`}
    placeholder="Nombre"
    autoComplete="off"
  />
  {errors.nombre && <p className="text-red-500 text-xs italic">{errors.nombre}</p>}

  {showSuggestions && suggestions.length > 0 && (
    <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded mt-1 shadow-md max-h-48 overflow-y-auto">
      {suggestions.map((s, idx) => (
        <li
          key={idx}
          onClick={() => {
            setFormData(prev => ({
              ...prev,
              nombre: s.nombre,
              tipoDocumento: s.tipoDocumento,
              documento: s.documento,
              codigoPostal: s.codigoPostal,
              provincia: s.provincia,
              pais: s.pais,
              domicilio: s.domicilio,
              telefono: s.telefono
            }));
            setShowSuggestions(false);
          }}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          {s.nombre}
        </li>
      ))}
    </ul>
  )}
</div>


       
       
       {/* <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombre">
            Nombre
          </label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.nombre ? 'border-red-500' : ''}`}
            placeholder="Nombre"
          />
          {errors.nombre && <p className="text-red-500 text-xs italic">{errors.nombre}</p>}
        </div>
        */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoDocumento">
            Tipo de Documento
          </label>
          <select
            name="tipoDocumento"
            value={formData.tipoDocumento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoDocumento ? 'border-red-500' : ''}`}
          >
            <option value="">Seleccione tipo de documento</option>
            <option value="NIF">NIF</option>
            <option value="NIE">NIE</option>
            <option value="CIF">CIF</option>
            <option value="CIF Admin">CIF Admin</option>
          </select>
          {errors.tipoDocumento && <p className="text-red-500 text-xs italic">{errors.tipoDocumento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="documento">
            Documento
          </label>
          <input
            type="text"
            name="documento"
            value={formData.documento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.documento ? 'border-red-500' : ''}`}
            placeholder="Documento"
          />
          {errors.documento && <p className="text-red-500 text-xs italic">{errors.documento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="codigoPostal">
            Código Postal
          </label>
          <input
            type="text"
            name="codigoPostal"
            value={formData.codigoPostal}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.codigoPostal ? 'border-red-500' : ''}`}
            placeholder="Código Postal"
          />
          {errors.codigoPostal && <p className="text-red-500 text-xs italic">{errors.codigoPostal}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="provincia">
            Provincia
          </label>
          <input
            type="text"
            name="provincia"
            value={formData.provincia}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.provincia ? 'border-red-500' : ''}`}
            placeholder="Provincia"
          />
          {errors.provincia && <p className="text-red-500 text-xs italic">{errors.provincia}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="pais">
            País
          </label>
          <input
            type="text"
            name="pais"
            value={formData.pais}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.pais ? 'border-red-500' : ''}`}
            placeholder="País"
          />
          {errors.pais && <p className="text-red-500 text-xs italic">{errors.pais}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilio">
            Domicilio
          </label>
          <input
            type="text"
            name="domicilio"
            value={formData.domicilio}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.domicilio ? 'border-red-500' : ''}`}
            placeholder="Domicilio"
          />
          {errors.domicilio && <p className="text-red-500 text-xs italic">{errors.domicilio}</p>}
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="telefono">
            Teléfono
          </label>
          <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.telefono ? 'border-red-500' : ''}`}
            placeholder="Teléfono"
          />
          {errors.telefono && <p className="text-red-500 text-xs italic">{errors.telefono}</p>}
        </div>
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Tercero'}
          </button>
        </div>
      </form>
    </div>
  
  );
}


/*
import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTerceroForm } from '../Validations/ValidationsTercero';

export default function AddTerceroForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    tipoDocumento: 'NIF',
    documento: '',
    codigoPostal: '06000',
    provincia: '-',
    pais: '-',
    domicilio: '-',
    telefono: '900000000'
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();

// Obtener el último DNI y asignar el siguiente
useEffect(() => {
  const fetchLastDni = async () => {
    try {
      const response = await axios.get('/terceros');
      const terceros = response.data || [];

      // Filtrar DNIs que siguen el formato "00000001*"
      const dniList = terceros
        .map(t => t.documento)
        .filter(dni => /^\d{8}\O$/.test(dni)) // Ahora busca 8 dígitos seguidos de "*"
        .map(dni => parseInt(dni.slice(0, 8), 10)); // Extrae solo los números

      // Obtener el último número y calcular el siguiente
      const lastNumber = dniList.length > 0 ? Math.max(...dniList) : 0;
      const nextDni = `${String(lastNumber + 1).padStart(8, '0')}O`; // 8 dígitos + "*"

      // Actualizar el estado con el nuevo DNI
      setFormData(prevData => ({
        ...prevData,
        documento: nextDni
      }));
    } catch (error) {
      console.error('Error obteniendo DNI:', error);
    }
  };

  fetchLastDni();
}, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    const validationErrors = await validateTerceroForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/terceros', formData);
        navigate('/home/terceros');
      } catch (err) {
        console.error('Error saving tercero:', err);
        setServerError(err.response?.data?.message || 'Error al guardar el tercero. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Tercero</h2>
      {serverError && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">{serverError}</div>}
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombre">
            Nombre
          </label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.nombre ? 'border-red-500' : ''}`}
            placeholder="Nombre"
          />
          {errors.nombre && <p className="text-red-500 text-xs italic">{errors.nombre}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoDocumento">
            Tipo de Documento
          </label>
          <select
            name="tipoDocumento"
            value={formData.tipoDocumento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoDocumento ? 'border-red-500' : ''}`}
          >
            <option value="">Seleccione tipo de documento</option>
            <option value="NIF">NIF</option>
            <option value="NIE">NIE</option>
            <option value="CIF">CIF</option>
            <option value="CIF Admin">CIF Admin</option>
          </select>
          {errors.tipoDocumento && <p className="text-red-500 text-xs italic">{errors.tipoDocumento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="documento">
            Documento
          </label>
          <input
            type="text"
            name="documento"
            value={formData.documento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.documento ? 'border-red-500' : ''}`}
            placeholder="Documento"
          />
          {errors.documento && <p className="text-red-500 text-xs italic">{errors.documento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="codigoPostal">
            Código Postal
          </label>
          <input
            type="text"
            name="codigoPostal"
            value={formData.codigoPostal}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.codigoPostal ? 'border-red-500' : ''}`}
            placeholder="Código Postal"
          />
          {errors.codigoPostal && <p className="text-red-500 text-xs italic">{errors.codigoPostal}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="provincia">
            Provincia
          </label>
          <input
            type="text"
            name="provincia"
            value={formData.provincia}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.provincia ? 'border-red-500' : ''}`}
            placeholder="Provincia"
          />
          {errors.provincia && <p className="text-red-500 text-xs italic">{errors.provincia}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="pais">
            País
          </label>
          <input
            type="text"
            name="pais"
            value={formData.pais}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.pais ? 'border-red-500' : ''}`}
            placeholder="País"
          />
          {errors.pais && <p className="text-red-500 text-xs italic">{errors.pais}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilio">
            Domicilio
          </label>
          <input
            type="text"
            name="domicilio"
            value={formData.domicilio}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.domicilio ? 'border-red-500' : ''}`}
            placeholder="Domicilio"
          />
          {errors.domicilio && <p className="text-red-500 text-xs italic">{errors.domicilio}</p>}
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="telefono">
            Teléfono
          </label>
          <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.telefono ? 'border-red-500' : ''}`}
            placeholder="Teléfono"
          />
          {errors.telefono && <p className="text-red-500 text-xs italic">{errors.telefono}</p>}
        </div>
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Tercero'}
          </button>
        </div>
      </form>
    </div>
  
  );
}

*/


/*
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTerceroForm } from '../Validations/ValidationsTercero';

export default function AddTerceroForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    tipoDocumento: '',
    documento: '',
    codigoPostal: '',
    provincia: '',
    pais: '',
    domicilio: '',
    telefono: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    const validationErrors = await validateTerceroForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/terceros', formData);
        navigate('/home/terceros');
      } catch (err) {
        console.error('Error saving tercero:', err);
        setServerError(err.response?.data?.message || 'Error al guardar el tercero. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Tercero</h2>
      {serverError && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">{serverError}</div>}
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombre">
            Nombre
          </label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.nombre ? 'border-red-500' : ''}`}
            placeholder="Nombre"
          />
          {errors.nombre && <p className="text-red-500 text-xs italic">{errors.nombre}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoDocumento">
            Tipo de Documento
          </label>
          <select
            name="tipoDocumento"
            value={formData.tipoDocumento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoDocumento ? 'border-red-500' : ''}`}
          >
            <option value="">Seleccione tipo de documento</option>
            <option value="NIF">NIF</option>
            <option value="NIE">NIE</option>
            <option value="CIF">CIF</option>
            <option value="CIF Admin">CIF Admin</option>
          </select>
          {errors.tipoDocumento && <p className="text-red-500 text-xs italic">{errors.tipoDocumento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="documento">
            Documento
          </label>
          <input
            type="text"
            name="documento"
            value={formData.documento}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.documento ? 'border-red-500' : ''}`}
            placeholder="Documento"
          />
          {errors.documento && <p className="text-red-500 text-xs italic">{errors.documento}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="codigoPostal">
            Código Postal
          </label>
          <input
            type="text"
            name="codigoPostal"
            value={formData.codigoPostal}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.codigoPostal ? 'border-red-500' : ''}`}
            placeholder="Código Postal"
          />
          {errors.codigoPostal && <p className="text-red-500 text-xs italic">{errors.codigoPostal}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="provincia">
            Provincia
          </label>
          <input
            type="text"
            name="provincia"
            value={formData.provincia}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.provincia ? 'border-red-500' : ''}`}
            placeholder="Provincia"
          />
          {errors.provincia && <p className="text-red-500 text-xs italic">{errors.provincia}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="pais">
            País
          </label>
          <input
            type="text"
            name="pais"
            value={formData.pais}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.pais ? 'border-red-500' : ''}`}
            placeholder="País"
          />
          {errors.pais && <p className="text-red-500 text-xs italic">{errors.pais}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilio">
            Domicilio
          </label>
          <input
            type="text"
            name="domicilio"
            value={formData.domicilio}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.domicilio ? 'border-red-500' : ''}`}
            placeholder="Domicilio"
          />
          {errors.domicilio && <p className="text-red-500 text-xs italic">{errors.domicilio}</p>}
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="telefono">
            Teléfono
          </label>
          <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.telefono ? 'border-red-500' : ''}`}
            placeholder="Teléfono"
          />
          {errors.telefono && <p className="text-red-500 text-xs italic">{errors.telefono}</p>}
        </div>
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Tercero'}
          </button>
        </div>
      </form>
    </div>
  
  );
}
*/